import React, { useEffect, Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Logo } from '../components/Logo';
export function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#f2efeb] text-[#2b2826] font-sans" data-id="element-804">
      {/* Header */}
      <header className="border-b border-[#2b2826]/10" data-id="element-805">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-5 flex items-center justify-between" data-id="element-806">
          <Link to="/" aria-label="ScaleWithLending home" data-id="element-807">
            <Logo data-id="element-808" />
          </Link>
          <Link to="/" className="text-sm text-[#2b2826]/70 hover:text-[#2b2826] transition-colors flex items-center gap-2" data-id="element-809">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-810" />
            Back to home
          </Link>
        </div>
      </header>

      {/* Main */}
      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-20" data-id="element-811">
        <div className="mb-12 pb-10 border-b border-[#2b2826]/10" data-id="element-812">
          <p className="text-xs uppercase tracking-[0.2em] text-[#c9a875] font-medium mb-4" data-id="element-813">
            Legal
          </p>
          <h1 className="font-serif-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-[#2b2826] mb-4" data-id="element-814">
            Privacy <span className="italic text-[#c9a875]" data-id="element-815">Policy</span>
          </h1>
          <p className="text-sm text-[#2b2826]/60" data-id="element-816">Last updated: May 8, 2026</p>
        </div>

        <article className="space-y-10 text-[#2b2826]/85 leading-relaxed" data-id="element-817">
          <div data-id="element-818">
            <p className="text-base" data-id="element-819">
              This Privacy Policy describes how <strong data-id="element-820">TRU OFFER LLC</strong>{' '}
              (doing business as ScaleWithLending, "we," "us," or "our")
              collects, uses, and shares information about you when you visit
              scalewithlending.com (the "Site") or submit a funding request.
            </p>
          </div>

          <div data-id="element-821">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-822">
              1. Information We Collect
            </h2>
            <p className="mb-4" data-id="element-823">
              When you submit our funding application form, we collect the
              following:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#2b2826]/80" data-id="element-824">
              <li data-id="element-825">
                <strong data-id="element-826">Contact information:</strong> first name, last name,
                email address, phone number.
              </li>
              <li data-id="element-827">
                <strong data-id="element-828">Property information:</strong> property address, city,
                state.
              </li>
              <li data-id="element-829">
                <strong data-id="element-830">Deal information:</strong> funding amount needed, deal
                type, exit strategy, experience level, inspection period end
                date, closing date, and any deal explanation you provide.
              </li>
              <li data-id="element-831">
                <strong data-id="element-832">Contract documents:</strong> URLs to purchase, A-B, and
                B-C contracts you choose to share.
              </li>
              <li data-id="element-833">
                <strong data-id="element-834">Site usage data:</strong> when you visit the Site, our
                hosting provider may automatically log standard request data (IP
                address, browser type, referring URL, pages visited).
              </li>
            </ul>
          </div>

          <div data-id="element-835">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-836">
              2. How We Use Your Information
            </h2>
            <p className="mb-4" data-id="element-837">We use the information you provide to:</p>
            <ul className="list-disc pl-6 space-y-2 text-[#2b2826]/80" data-id="element-838">
              <li data-id="element-839">Review and underwrite your funding request.</li>
              <li data-id="element-840">
                Communicate with you about your application, follow up on
                missing items, and provide a term sheet if applicable.
              </li>
              <li data-id="element-841">
                Coordinate with title companies, escrow agents, and counterparty
                lenders involved in closing your transaction.
              </li>
              <li data-id="element-842">Comply with legal and regulatory obligations.</li>
              <li data-id="element-843">
                Improve our services and, with your consent, send periodic
                updates or educational content.
              </li>
            </ul>
          </div>

          <div data-id="element-844">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-845">
              3. Third-Party Services
            </h2>
            <p className="mb-4" data-id="element-846">
              We use trusted third-party services to operate the Site and
              process your application. These include:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#2b2826]/80" data-id="element-847">
              <li data-id="element-848">
                <strong data-id="element-849">Zapier:</strong> when you submit the funding form, the
                data is transmitted through Zapier to our internal systems (CRM,
                email, or spreadsheet) for review.
              </li>
              <li data-id="element-850">
                <strong data-id="element-851">Hosting providers:</strong> our Site is hosted on
                infrastructure that processes standard server logs.
              </li>
              <li data-id="element-852">
                <strong data-id="element-853">Title companies and capital partners:</strong> when
                actively underwriting or closing a deal, we share relevant
                deal-specific information with the parties needed to fund and
                close the transaction.
              </li>
            </ul>
            <p className="mt-4" data-id="element-854">
              We do not sell your personal information to third parties for
              advertising purposes.
            </p>
          </div>

          <div data-id="element-855">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-856">
              4. Data Retention
            </h2>
            <p data-id="element-857">
              We retain funding application data for as long as necessary to
              service your deal, comply with our legal and recordkeeping
              obligations, and support our internal business operations. Records
              related to closed transactions are typically retained for a
              minimum of seven (7) years. You may request deletion of records
              not subject to a legal hold by contacting us at the address below.
            </p>
          </div>

          <div data-id="element-858">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-859">
              5. Your Privacy Rights
            </h2>
            <p className="mb-4" data-id="element-860">
              Depending on your state of residence (including California,
              Colorado, Connecticut, Virginia, and Utah), you may have the
              following rights:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#2b2826]/80" data-id="element-861">
              <li data-id="element-862">The right to know what personal information we collect.</li>
              <li data-id="element-863">The right to access a copy of your personal information.</li>
              <li data-id="element-864">
                The right to request correction of inaccurate information.
              </li>
              <li data-id="element-865">
                The right to request deletion (subject to legal exceptions).
              </li>
              <li data-id="element-866">
                The right to opt out of the sale or sharing of personal
                information.
              </li>
            </ul>
            <p className="mt-4" data-id="element-867">
              To exercise any of these rights, email{' '}
              <a href="mailto:support@truoffer.co" className="text-[#c9a875] underline hover:no-underline" data-id="element-868">
                support@truoffer.co
              </a>
              . We will respond within the time required by applicable law.
            </p>
          </div>

          <div data-id="element-869">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-870">
              6. Cookies
            </h2>
            <p data-id="element-871">
              The Site uses minimal cookies and similar technologies for
              functional purposes (e.g., remembering form progress) and basic
              traffic analytics. You can disable cookies in your browser
              settings, though some features of the Site may not function
              correctly.
            </p>
          </div>

          <div data-id="element-872">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-873">
              7. Children's Privacy
            </h2>
            <p data-id="element-874">
              The Site is not directed to children under 18, and we do not
              knowingly collect personal information from children.
            </p>
          </div>

          <div data-id="element-875">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-876">
              8. Changes to This Policy
            </h2>
            <p data-id="element-877">
              We may update this Privacy Policy from time to time. The "Last
              updated" date at the top reflects the most recent changes.
              Continued use of the Site after changes constitutes acceptance of
              the revised policy.
            </p>
          </div>

          <div data-id="element-878">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-879">
              9. Contact Us
            </h2>
            <p data-id="element-880">
              For questions about this Privacy Policy or our data practices,
              contact:
            </p>
            <div className="mt-4 bg-white border border-[#2b2826]/10 rounded-2xl p-6" data-id="element-881">
              <p className="font-medium text-[#2b2826]" data-id="element-882">TRU OFFER LLC</p>
              <p className="text-[#2b2826]/70 text-sm mt-1" data-id="element-883">
                d/b/a ScaleWithLending
              </p>
              <p className="text-[#2b2826]/70 text-sm mt-3" data-id="element-884">
                Email:{' '}
                <a href="mailto:support@truoffer.co" className="text-[#c9a875] underline hover:no-underline" data-id="element-885">
                  support@truoffer.co
                </a>
              </p>
            </div>
          </div>
        </article>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#2b2826]/10 mt-12" data-id="element-886">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#2b2826]/50" data-id="element-887">
          <span data-id="element-888">
            © {new Date().getFullYear()} TRU OFFER LLC. All rights reserved.
          </span>
          <div className="flex gap-5" data-id="element-889">
            <Link to="/privacy" className="hover:text-[#2b2826] transition-colors" data-id="element-890">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-[#2b2826] transition-colors" data-id="element-891">
              Terms
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}